import { useTranslation } from '@/i18n';
import { useNavigate } from 'react-router-dom';
import { useScrollReveal } from './useScrollReveal';

export function CtaSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sectionRef = useScrollReveal();

  return (
    <section
      ref={sectionRef}
      className="landing-reveal relative overflow-hidden py-20 md:py-28"
    >
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-sky-500 to-indigo-600" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.15),_transparent_50%)]" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white">
          {t('landing.cta.headline')}
        </h2>
        <p className="mt-4 text-lg text-sky-100 max-w-xl mx-auto">
          {t('landing.cta.subtitle')}
        </p>
        <button
          onClick={() => void navigate('/merchant/login')}
          className="mt-8 inline-flex items-center px-8 py-4 text-base font-semibold text-sky-600 bg-white rounded-lg hover:bg-sky-50 shadow-lg transition-all min-h-[44px] cursor-pointer"
        >
          {t('landing.cta.button')}
          <svg
            className="w-4 h-4 ml-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </section>
  );
}
